/**
 * The locales supported by Verdi clients. This list is the single source of truth —
 * the dashboard, backend, and any other client must derive their language list from
 * here rather than maintaining a parallel constant.
 */
export const LOCALES = ["en-CA", "en-US", "fr-CA", "es-MX", "ja-JP", "pt-PT", "pa-IN"] as const;

export type Locale = (typeof LOCALES)[number];

/**
 * The locale used as the canonical English source. Catalog entries in this locale
 * (added in follow-up PRs) must be complete; entries in other locales fall back to
 * this when absent.
 */
export const DEFAULT_LOCALE = "en-CA" as const satisfies Locale;

/**
 * i18next namespaces owned by `verdi-common`. The `WARNINGS` namespace holds the warning
 * translation catalog; `SENSOR_NAMING` holds the sensor/unit display-name catalog (unit
 * categories and sensor element descriptors); `TIMEZONES` holds the generated IANA-zone city
 * names. Declared here so the dashboard (and any other consumer) can wire up the namespace
 * name without hard-coding the string.
 */
export const NAMESPACES = {
    WARNINGS: "warnings",
    NOTIFICATIONS: "notifications",
    SENSOR_NAMING: "sensorNaming",
    TIMEZONES: "timezones",
} as const;
